import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Paper, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AccessDeniedState = ({ backPath, message }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  return (
    <Box sx={{ p: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          maxWidth: 480,
          textAlign: 'center',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: '#fef2f2',
            color: '#ef4444',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          {t('accessDenied.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {message || t('accessDenied.message')}
        </Typography>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => (backPath ? navigate(backPath) : navigate(-1))}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {t('accessDenied.back')}
        </Button>
      </Paper>
    </Box>
  );
};

AccessDeniedState.propTypes = {
  backPath: PropTypes.string,
  message: PropTypes.string,
};

export default AccessDeniedState;
